module.exports = __webpack_public_path__ + "static/far-cry_fullpage-cf11febdbec4bf83b90ac1cb2303e057.jpg";